module.exports = "https://portperrypedals.ca/_res/img/pedals-start.d060947.jpg";